import React from 'react';
import { decorateData } from '../common/OrderUtil';
import Loading from '../loading';
import {
  columnDataForStatement,
  columnDataForStatementReturns,
  columnDataForStatementReturnedToOnceit,
  valueFormat,
  monthes,
} from '../common/constants';
import { getStatements, getCurrentSupplierId } from '../../api';
import { currentDateForStatement } from '../common/OrderUtil';
import Summarization from './Summarization';
import EnhancedTableToolbar from './StatementTableToolbar';
import AlertDialog from '../common/AlertDialog';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const { formatMoney } = require('accounting');

const ONCEIT_DC_RETURN_COST_PER_ITEM = 5; // Assuming the cost for return to DC is $5 per item

class Statements extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: true,
      result: props.result
        ? props.result
        : {
            orders: { data: [] },
            returns: { data: [] },
            metadata: {
              year: currentDateForStatement().year(),
              month: currentDateForStatement().month(),
            },
            summary: {
              items: {
                orderQty: 0,
                itemQty: 0,
                totalCost: 0,
              },
              shippingCost: {
                orderQty: 0,
                itemQty: 0,
                totalCost: 0,
              },
              orders: {
                orderQty: 0,
                itemQty: 0,
                totalCost: 0,
              },
              returns: {
                orderQty: 0,
                itemQty: 0,
                totalCost: 0,
                shippingCost: {
                  totalCost: 0.0,
                },
              },
              returnsToDC: {
                totalCost: 0.0,
                itemQty: 0,
              },
            },
          },
      filters: {
        year: currentDateForStatement().year(),
        month: currentDateForStatement().month(),
      },
      pageInfo: {
        pageSize: 20, // Defaults to 20 if not specified
        page: 0,
        order: 'asc',
        orderBy: 'created_at',
      },
    };
  }

  componentWillMount() {
    this.loadData();
  }

  loadData = () => {
    this.setState({ isFetching: true }, () =>
      // getStatements(merge(this.state.filters, this.state.pageInfo)).then(result => {
      getStatements(this.state.filters).then(result => {
        if (result && result.errors && result.errors.length > 0) {
          this.setState({ errors: result.errors, isFetching: false });
        } else {
          if (!result.data) {
            this.setState({
              errors: [{ message: 'The statement for the period selected is not available' }],
              isFetching: false,
            });
          }
          const currencies = {};
          const retultValues = {
            orders: { data: decorateData(result.data ? result.data.orders : []) },
            returns: { data: decorateData(result.data ? result.data.returns : []) },
            marketplaceReturnToDC: {
              data: decorateData(result.data ? result.data.marketplaceReturnToDC : []),
            },
            currency: '',
            subscriptionFee:
              result.data && result.data.subscriptionFee ? Number(result.data.subscriptionFee) : 0,
            marketplaceReturnToDcTotalItems:
              result.data && result.data.marketplaceReturnToDcTotalItems
                ? Number(result.data.marketplaceReturnToDcTotalItems)
                : 0,
          };
          retultValues.summary = {
            items: {
              itemQty: 0,
              totalCost: 0.0,
            },
            shippingCost: {
              totalCost: 0.0,
            },
            orders: {
              orderQty: retultValues.orders.data.length,
              totalCost: 0,
            },
            returns: {
              orderQty: retultValues.returns.data.length,
              itemQty: 0,
              totalCost: 0.0,
              shippingCost: {
                totalCost: 0.0,
              },
            },
            returnsToDC: {
              itemQty: retultValues.marketplaceReturnToDcTotalItems || 0,
              totalCost:
                (retultValues.marketplaceReturnToDcTotalItems || 0) *
                ONCEIT_DC_RETURN_COST_PER_ITEM,
            },
          };
          // add orders summarize
          retultValues.orders.data.forEach(shipmentOrder => {
            retultValues.summary.orders.totalCost += shipmentOrder.totalCostIncludeReturnWithoutGst;
            retultValues.summary.items.totalCost +=
              shipmentOrder.totalCostIncludeReturnWithoutShippingCostWithoutGst;
            retultValues.summary.shippingCost.totalCost += shipmentOrder.shippingCostWithoutGst;

            shipmentOrder.products.forEach(product => {
              currencies[product.currency.toUpperCase()] = 1;
              retultValues.summary.items.itemQty += product.quantityIncludeReturn;
            });
          });
          // add returns summary
          retultValues.returns.data.forEach(shipmentOrder => {
            retultValues.summary.returns.shippingCost.totalCost +=
              shipmentOrder.notAllReturnedShippingCostWithoutGst;
            retultValues.summary.returns.totalCost +=
              shipmentOrder.returnTotalCostWithoutShippingCostWithoutGst;
            shipmentOrder.products.forEach(product => {
              currencies[product.currency.toUpperCase()] = 1;
              retultValues.summary.returns.itemQty += product.returnQuantity;
            });
          });
          retultValues.currency = Object.keys(currencies);

          // Check the quantity of currencies in current report
          if (currencies && retultValues.currency.length > 1) {
            this.setState({
              errors: [
                {
                  message: `There are more than 1 currencies in the statement, they are ${retultValues.currency.toString()}`,
                },
              ],
              isFetching: false,
            });
          }
          retultValues.currency = retultValues.currency.toString();
          this.setState({ result: retultValues, isFetching: false });
        }
      })
    );
  };

  handleFilter = filtersObj => {
    const filters = this.state.filters;
    if (filtersObj) {
      Object.keys(filtersObj).forEach(key => {
        filters[key] = filtersObj[key];
        // filter blank filter
        if (filters[key] === '') {
          delete filters[key];
        }
      });
    }

    const pageInfo = this.state.pageInfo;
    pageInfo.page = 0;
    this.setState({ filters, pageInfo });
    this.doFilter();
  };

  handleChangePage = page => {
    const pageInfo = this.state.pageInfo;
    pageInfo.page = page;
    this.setState({ pageInfo });
    this.loadData();
  };

  handleChangePageSize = value => {
    const pageInfo = this.state.pageInfo;
    pageInfo.pageSize = value;
    pageInfo.page = 0;
    this.setState({ pageInfo });
    this.loadData();
  };

  doExport = type => {
    this.setState({ isFetching: true }, () => {
      const { result } = this.state;

      const summaryData = [
        {
          Title: 'Items',
          Quantity: `${result.summary.items.itemQty}`,
          'Total Cost (GST excluded)': formatMoney(result.summary.items.totalCost),
        },
        {
          Title: 'Shipping Cost',
          Quantity: '',
          'Total Cost (GST excluded)': formatMoney(result.summary.shippingCost.totalCost),
        },
        {
          Title: 'Orders Total',
          Quantity: `${result.summary.orders.orderQty}`,
          'Total Cost (GST excluded)': formatMoney(result.summary.orders.totalCost),
        },
        {
          Title: 'Credit Shipping Cost (*)',
          Quantity: '',
          'Total Cost (GST excluded)': formatMoney(result.summary.returns.shippingCost.totalCost),
        },
        {
          Title: 'Credit Items (*)',
          Quantity: `${result.summary.returns.itemQty}`,
          'Total Cost (GST excluded)': formatMoney(result.summary.returns.totalCost),
        },
        {
          Title: 'Subscription Fee',
          Quantity: '',
          'Total Cost (GST excluded)': formatMoney(result.subscriptionFee),
        },
        {
          Title: 'Return to Onceit Fee ($5 per item)',
          Quantity: `${result.summary.returnsToDC.itemQty}`,
          'Total Cost (GST excluded)': formatMoney(result.summary.returnsToDC.totalCost),
        },
        {
          Title: 'Total',
          Quantity: '',
          'Total Cost (GST excluded)': formatMoney(
            result.summary.orders.totalCost -
              result.summary.returns.totalCost -
              result.summary.returns.shippingCost.totalCost -
              result.subscriptionFee -
              result.summary.returnsToDC.totalCost
          ),
        },
      ];

      // 2. Data for Sheet 2: Orders
      const ordersDataList = [];
      result.orders.data.map(order => {
        const orderData = {};
        columnDataForStatement.map(item => {
          if (order[item.id] && typeof order[item.id] === 'object') {
            if (item.id === 'productShowNameWithoutBarCode') {
              orderData[item.label] = order[item.id]
                .map(value => valueFormat(item, value))
                .join('\n');
            } else {
              orderData[item.label] = order[item.id]
                .map(value => valueFormat(item, value))
                .join('\n');
            }
          } else {
            orderData[item.label] = valueFormat(item, order[item.id]);
          }
        });
        ordersDataList.push(orderData);
      });

      // 3. Data for Sheet 3: Credit items
      const creditItemsDataList = [];
      result.returns.data.map(order => {
        const itemData = {};
        columnDataForStatementReturns.map(item => {
          if (order[item.id] && typeof order[item.id] === 'object') {
            if (item.id === 'productShowNameWithoutBarCode') {
              itemData[item.label] = order[item.id]
                .map(value => valueFormat(item, value))
                .join('\n');
            } else {
              itemData[item.label] = order[item.id]
                .map(value => valueFormat(item, value))
                .join('\n');
            }
          } else {
            itemData[item.label] = valueFormat(item, order[item.id]);
          }
        });
        creditItemsDataList.push(itemData);
      });

      // 4. Data for Sheet 3: Returned to Onceit Items
      const returnedToOnceitsDataList = [];
      result.marketplaceReturnToDC.data.map(order => {
        const itemData = {};
        columnDataForStatementReturnedToOnceit.map(item => {
          if (order[item.id] && typeof order[item.id] === 'object') {
            if (item.id === 'productShowNameWithoutBarCode') {
              itemData[item.label] = order[item.id]
                .map(value => valueFormat(item, value))
                .join('\n');
            } else {
              itemData[item.label] = order[item.id]
                .map(value => valueFormat(item, value))
                .join('\n');
            }
          } else {
            itemData[item.label] = valueFormat(item, order[item.id]);
          }
        });
        returnedToOnceitsDataList.push(itemData);
      });

      // Convert each array of objects to an individual worksheet
      const worksheetSummary = XLSX.utils.json_to_sheet(summaryData);
      const worksheetUsers = XLSX.utils.json_to_sheet(ordersDataList);
      const worksheetProducts = XLSX.utils.json_to_sheet(creditItemsDataList);
      const worksheetReturnedToOnceits = XLSX.utils.json_to_sheet(returnedToOnceitsDataList);

      // Create a new empty workbook
      const workbook = XLSX.utils.book_new();

      // Append each worksheet with a custom sheet name
      XLSX.utils.book_append_sheet(workbook, worksheetSummary, 'Summary');
      XLSX.utils.book_append_sheet(workbook, worksheetUsers, 'Orders');
      XLSX.utils.book_append_sheet(workbook, worksheetProducts, 'Credit Items');
      XLSX.utils.book_append_sheet(
        workbook,
        worksheetReturnedToOnceits,
        'Returned to Onceit Items'
      );

      // Generate binary array buffer
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

      // Create a Blob and trigger the file download
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      });

      saveAs(
        blob,
        `Statements-${getCurrentSupplierId()}(${this.state.filters.year} - ${
          monthes[this.state.filters.month]
        }).xlsx`
      );
    });
    this.setState({ isFetching: false });
  };

  doFilter = () => {
    this.loadData();
  };

  handleCloseAlert = type => {
    this.setState({ errors: null });
  };

  render() {
    const { result, pageInfo, errors, filters, isFetching } = this.state;
    const parameters =
      errors && errors.length > 0
        ? {
            title: 'Errors',
            message: errors.map(error => error.message),
            okButtonName: 'OK',
            handleClose: this.handleCloseAlert,
          }
        : {};

    return (
      <div style={{ marginTop: '50px' }}>
        <EnhancedTableToolbar
          handleFilter={this.handleFilter}
          doRest={this.doRest}
          filters={filters}
          doExport={this.doExport}
          result={result}
        />

        <Summarization
          summaries={[
            {
              label: 'Items',
              values: [
                {
                  label: 'Quantity',
                  value: `${result.summary.items.itemQty}`,
                },
                {
                  label: 'Total Cost (GST excluded)',
                  value: formatMoney(result.summary.items.totalCost),
                },
              ],
            },
            {
              label: 'Shipping Cost',
              values: [
                {
                  label: 'Quantity',
                  value: '',
                },
                {
                  label: 'Total Cost (GST excluded)',
                  value: formatMoney(result.summary.shippingCost.totalCost),
                },
              ],
            },
            {
              label: 'Orders Total',
              values: [
                {
                  label: 'Quantity',
                  value: `${result.summary.orders.orderQty}`,
                },
                {
                  label: 'Total Cost (GST excluded)',
                  value: formatMoney(result.summary.orders.totalCost),
                  style: {
                    fontWeight: 'bold',
                  },
                },
              ],
            },
            {
              label: 'Credit Shipping Cost (*)',
              values: [
                {
                  label: 'Quantity',
                  value: '',
                },
                {
                  label: ' Cost (GST excluded)',
                  value: formatMoney(result.summary.returns.shippingCost.totalCost),
                },
              ],
            },
            {
              label: 'Credit Items (*)',
              values: [
                {
                  label: 'Quantity',
                  value: result.summary.returns.itemQty,
                },
                {
                  label: 'Total Cost (GST excluded)',
                  value: formatMoney(result.summary.returns.totalCost),
                },
              ],
            },
            {
              label: 'Subscription Fee',
              values: [
                {
                  label: 'Quantity',
                  value: '',
                },
                {
                  label: 'Total Cost (GST excluded)',
                  value: formatMoney(result.subscriptionFee),
                },
              ],
            },
            {
              label: 'Return to Onceit Fee ($5 per item)',
              values: [
                {
                  label: 'Quantity',
                  value: result.summary.returnsToDC.itemQty,
                },
                {
                  label: 'Total Cost (GST excluded)',
                  value: formatMoney(result.summary.returnsToDC.totalCost),
                },
              ],
            },
            {
              label: 'Total:',
              values: [
                {
                  label: 'Quantity',
                  value: '',
                },
                {
                  label: 'Total Cost (GST excluded)',
                  value: formatMoney(
                    result.summary.orders.totalCost -
                      result.summary.returns.totalCost -
                      result.summary.returns.shippingCost.totalCost -
                      result.subscriptionFee -
                      result.summary.returnsToDC.totalCost
                  ),
                  style: {
                    background: '#789afd',
                    color: 'white',
                    fontWeight: 'bold',
                  },
                },
              ],
            },
          ]}
          withOutToolBar
          result={result}
          filters={filters}
          pageInfo={this.state.pageInfo}
          handleChangePage={this.handleChangePage}
          handleChangePageSize={this.handleChangePageSize}
        />
        <Loading show={this.state.isFetching} text="Loading..." />
        {errors && errors.length > 0 && <AlertDialog parameters={parameters} />}
      </div>
    );
  }
}

export default Statements;



// WEBPACK FOOTER //
// ./src/components/statements/index.js